import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "./assets/css/custom.css";
import MaterialDashboard from "./material-dashboard";
import setupInterceptors from './services/setupInterceptors';

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(MaterialDashboard);
setupInterceptors(store);
appInstance.mount("#app");
